import { render, staticRenderFns } from "./ReportDashboard.vue?vue&type=template&id=5b1c2bee&scoped=true&"
import script from "./ReportDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReportDashboard.vue?vue&type=style&index=0&id=5b1c2bee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c2bee",
  null
  
)

export default component.exports